import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AccountService } from '../account/shared/account.service';
import { ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Webshops } from '../../store/models/webshops';
import { Warenkorb } from '../../store/models/warenkorb';
import { WarenkorbsService } from '../../webshops/warenkorbs/shared/warenkorbs.service';
import { LayoutUtilsService, MessageType } from 'src/app/core/layout-utils.service';
import { event } from 'jquery';
import { endWith } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { Kunde } from '../../store/models/kunde';
import { Observable } from 'rxjs'; // Importiere Observable
import { map } from 'rxjs/operators'; // Importiere 'map' aus 'rxjs/operators'

@Component({
    selector: 'kkis-app-webshop-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    encapsulation: ViewEncapsulation.None //https://stackoverflow.com/questions/46403698/css-values-not-applying-on-dynamically-injected-html-div-elements-in-angular-4
})
export class WebshopAccountComponent implements OnInit {

    @Output()
    numberWarenkorbItems: EventEmitter<number> = new EventEmitter<number>();

    receipts: Webshops.IReceiptDto[];

    //isLoading: boolean = true;

    // Search
    search: string = "";
    loadcount: number;
    maxcount:number;

    constructor(
        private router: Router,
        private accountsService: AccountService,
        private warenkorbsService: WarenkorbsService,
        private layoutUtilsService: LayoutUtilsService
    ) {

    }

    handleClick(event: MouseEvent): void {

        const clickedElement = event.target as HTMLElement;

        switch (clickedElement.id) {
            case 'kundenkonto_custno':
                const elem = document.getElementById('kundenkonto_head');
                elem.classList.toggle('show');
                break;
        }

    }

    ngOnInit(): void {

        //this.isLoading = true;

        this.loadcustomerdata();

        this.loadreceipts("A", false);
        this.loadreceipts("A", true);

        this.loadreceipts("B", false);
        this.loadreceipts("B", true);

        this.loadreceipts("L", false);
        this.loadreceipts("L", true);

        this.loadcount = 0;
        this.maxcount = 6;
    }

    ngAfterViewInit() {

        document.getElementById('div_account').addEventListener('click', (event) => {

            //document.addEventListener('click', (event) => {
            //alert(event.target)    
            //console.log(event.target);

            var el = event.target;

            if ($(el).hasClass('col_expand')) {

                $(el).toggleClass('expanded');
                $(el).parents('.receipt').find('.cont_pos_header').toggleClass('hidden');
                $(el).parents('.receipt').find('.position').toggleClass('hidden');

            } else if ($(el).hasClass('head_expand')) {

                $(el).toggleClass('expanded');
                $(el).parents('.receipt_group').toggleClass('expanded');

            } else if ($(el).hasClass('col_rec_wk')) {
                //Alle Artikel des Beleges in den Warenkorb legen
                this.onAddReceiptToWarenkorb(event);

                //funktioniert
                /*
                var later_this = this;

                $(el).parents('.receipt').find('.position').each(function () {
                    
                    let anzahl = $(this).data('anzahl');
                    let id;
                    if ($(this).data('matrixid')) {
                        id = $(this).data('matrixid');
                    } else {
                        id = $(this).data('id');
                    }
                    let ismatrixArtikel = ($(this).data('matrixid') ? true : false);

                    later_this.onAddToWarenkorb(id, anzahl, ismatrixArtikel);

                })
                */

            } else if ($(el).hasClass('col_pos_wk')) {
                //Position in Warenkorb legen
                //Menge 1 oder Menge aus Position? abfragen

                let anzahl = $(el).parents('.position').data('anzahl');
                let id;
                if ($(el).parents('.position').data('matrixid')) {
                    id = $(el).parents('.position').data('matrixid');
                } else {
                    id = $(el).parents('.position').data('id');
                }
                let ismatrixArtikel = ($(el).parents('.position').data('matrixid') ? true : false);

                this.onAddToWarenkorb(id, anzahl, ismatrixArtikel);

            }
        });

        const selectElement = document.getElementById('filter_customer') as HTMLSelectElement;

        selectElement.addEventListener('change', (event: Event) => {
            this.onSearch()
        });

        //this.isLoading = false;
    }

    loadreceipts(belegart: string, archive: boolean) {

        this.accountsService.getReceiptlistAsync(belegart, archive).subscribe(res => {

            this.receipts = res;

            if (this.receipts.length > 0) {
                //einblenden!!!

                $('#div_' + belegart).show();

                var cont_receipt = "";

                //receipt col header
                var cont_receipt_header = "<div class='cont_receipt_header'>";
                cont_receipt_header += "<div class='col_space'></div>";
                cont_receipt_header += "<div class='receipt_col_h col_webshop_jn'></div>";
                cont_receipt_header += "<div class='receipt_col_h col_belegnr'>Beleg-Nr.</div>";
                cont_receipt_header += "<div class='receipt_col_h col_date'>Datum</div>";
                cont_receipt_header += "<div class='receipt_col_h col_summe_netto'>Summe netto</div>";
                cont_receipt_header += "<div class='receipt_col_h col_summe_brutto'>Summe brutto</div>";
                cont_receipt_header += "<div class='receipt_col_h col_kd_auftrag_nr'>Kd.-Auftragsnr.</div>";
                cont_receipt_header += "<div class='receipt_col_h col_kd_auftrag_datum'>Datum Auftrag</div>";

                cont_receipt_header += "</div>";


                for (var i = 0; i < this.receipts.length; i++) {
                    //console.log('i: ' + i);
                    var alternativ = (this.receipts[i].kundenKennungHauptkunde == this.receipts[i].kundenKennung ? "N" : "J");

                    cont_receipt += "<div class='receipt' data-belegnr='" + this.receipts[i].belegNr + "' data-search='$xxx$' data-alternativ='" + alternativ + "' data-kennung='" + this.receipts[i].kundenKennung + "'>";

                    cont_receipt += "<div style='display: flow-root;'>";

                    cont_receipt += "<div class='receipt_cols'>";
                    cont_receipt += "<div class='col_expand'></div>";
                    cont_receipt += "<div class='receipt_col col_webshop_jn" + (this.receipts[i].auftragsart == '98' ? ' ws' : '') + "'" + (this.receipts[i].auftragsart == '98' ? ' title="Webshop-Beleg"' : '') + "></div>";
                    cont_receipt += "<div class='receipt_col col_belegnr' " + (alternativ == 'J' ? "title='alternative Lieferadresse'" : "") + ">" + this.receipts[i].belegNr + '-' + this.receipts[i].belegNrZusatz + "</div>";

                    let mydate = new Date(this.receipts[i].datum);
                    cont_receipt += "<div class='receipt_col col_date'>" + mydate.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) + "</div>";

                    cont_receipt += "<div class='receipt_col col_summe_netto'>" + this.receipts[i].summe_netto.toFixed(2).replace('.', ',') + "€</div>";
                    cont_receipt += "<div class='receipt_col col_summe_brutto'>" + this.receipts[i].summe_brutto.toFixed(2).replace('.', ',') + "€</div>";

                    cont_receipt += "<div class='receipt_col col_kd_auftrag_nr'>" + (this.receipts[i].kd_auftrag_nr == null ? '' : this.receipts[i].kd_auftrag_nr) + "</div>";

                    var datestr_auftrag = '';
                    if (this.receipts[i].kd_auftrag_datum != null) {
                        let mydate2 = new Date(this.receipts[i].kd_auftrag_datum);
                        datestr_auftrag = mydate2.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
                    }
                    cont_receipt += "<div class='receipt_col col_kd_auftrag_datum'>" + datestr_auftrag + "</div>";

                    cont_receipt += "</div>";

                    cont_receipt += "<div class='col_rec_wk flaticon2-shopping-cart-1' title='ALLE Artikel in den Warenkorb legen'></div>";
                    cont_receipt += "</div>";

                    if (this.receipts[i].positionen.length > 0) {

                        var cont_pos = "";
                        var cont_pos_header = "<div class='cont_pos_header hidden'>";
                        cont_pos_header += "<div class='col_pos_posnr'>Nr.</div>";
                        cont_pos_header += "<div class='col_pos_anzahl'>Anzahl</div>";
                        cont_pos_header += "<div class='col_pos_artnr'>Art.-Nr.</div>";
                        cont_pos_header += "<div class='col_pos_artl'>Bezeichnung</div>";
                        cont_pos_header += "<div class='col_pos_preis_2 h'>Preis</div>";
                        cont_pos_header += "<div class='col_pos_preis'>Gesamtpreis</div>";

                        if (belegart == "B") {
                            cont_pos_header += "<div class='col_pos_anzahl'>Anzahl</div>";
                            cont_pos_header += "<div class='col_pos_geliefert'>geliefert</div>";
                            cont_pos_header += "<div class='col_pos_rest'>Rest</div>";
                            cont_pos_header += "<div class='col_pos_termin'>Termin</div>";
                        }

                        cont_pos_header += "</div>";

                        var cont_search = "";
                        var color_class = "";

                        for (let i_pos = 0; i_pos < this.receipts[i].positionen.length; i_pos++) {
                            //console.log("postyp: "+this.receipts[i].positionen[i_pos].typ);
                            var tp = (this.receipts[i].positionen[i_pos].typ == null || this.receipts[i].positionen[i_pos].typ == "" ? true : false);
                            //console.log("tp: "+tp);
                            cont_pos += "<div class='position theme-customer-hov hidden'";

                            cont_pos += " data-id='" + this.receipts[i].positionen[i_pos].artikelId + "'";
                            if (this.receipts[i].positionen[i_pos].matrixId > 0) {
                                cont_pos += " data-matrixid='" + this.receipts[i].positionen[i_pos].matrixId + "'";
                            }
                            cont_pos += " data-anzahl='" + this.receipts[i].positionen[i_pos].anzahl + "'";
                            cont_pos += " data-artnr='" + this.receipts[i].positionen[i_pos].artNr + "'";
                            cont_pos += " data-artl='" + this.receipts[i].positionen[i_pos].artL + "'";
                            cont_pos += " data-textpos='" + tp + "'";

                            cont_pos += ">";

                            cont_pos += "<div>";

                            cont_pos += "<div class='pos_cols'>";

                            if (tp == false) {

                                //normale Materialposition
                                cont_pos += "<div class='pos_col col_pos_posnr'>" + this.receipts[i].positionen[i_pos].position + "</div>";                                
                                cont_pos += "<div class='pos_col col_pos_anzahl'>" + (this.receipts[i].positionen[i_pos].anzahl == null ? "0" : this.receipts[i].positionen[i_pos].anzahl.toString()).replace('.', ',') + "</div>";
                                cont_pos += "<div class='pos_col col_pos_artnr'>" + this.receipts[i].positionen[i_pos].artNr + "</div>";

                                cont_pos += "<div class='pos_col'>";
                                cont_pos += "<div class='pos_col_inner col_pos_artl'>" + this.receipts[i].positionen[i_pos].artL + "</div>";
                                if (this.receipts[i].positionen[i_pos].matrixId > 0) {
                                    cont_pos += "<div class='pos_col col_pos_matrix'>" + this.receipts[i].positionen[i_pos].farbe + "/" + this.receipts[i].positionen[i_pos].groesse + "</div>";
                                }
                                cont_pos += "</div>";

                                //console.log(this.receipts[i].belegNr+ '  '+this.receipts[i].positionen[i_pos].preis_2);
                                //console.log(this.receipts[i].positionen[i_pos]);
                                cont_pos += "<div class='pos_col col_pos_preis_2'>" + (this.receipts[i].positionen[i_pos].preis_2 == null ? "" : this.receipts[i].positionen[i_pos].preis_2.toFixed(2).replace('.', ',') + "€") + "</div>";
                                cont_pos += "<div class='pos_col col_pos_preis'>" + (this.receipts[i].positionen[i_pos].preis == null ? "" : this.receipts[i].positionen[i_pos].preis.toFixed(2).replace('.', ',') + "€") +"</div>";

                                if (belegart == "B") {
                                    cont_pos += "<div class='pos_col col_pos_anzahl'>" + this.receipts[i].positionen[i_pos].anzahl + "</div>";
                                    cont_pos += "<div class='pos_col col_pos_geliefert'>" + (this.receipts[i].positionen[i_pos].abrufDiff == null ? "0" : this.receipts[i].positionen[i_pos].abrufDiff) + "</div>";

                                    color_class = this.receipts[i].positionen[i_pos].abrufRest > 0 ? "red" : "green";

                                    cont_pos += "<div class='pos_col col_pos_rest " + color_class + "'>" + (this.receipts[i].positionen[i_pos].abrufRest == null ? "0" : this.receipts[i].positionen[i_pos].abrufRest) + "</div>";

                                    cont_pos += "<div class='pos_col col_pos_termin'>";
                                    if (this.receipts[i].positionen[i_pos].bestellPositionen != null) {

                                        for (var i_bestpos = 0; i_bestpos < this.receipts[i].positionen[i_pos].bestellPositionen.length; i_bestpos++) {

                                            const termin = new Date(this.receipts[i].positionen[i_pos].bestellPositionen[i_bestpos].termin);

                                            cont_pos += "<div>" + formatDate(termin, 'dd.MM.yyyy', 'de_DE') + " (" + this.receipts[i].positionen[i_pos].bestellPositionen[i_bestpos].anzahl + ")</div>";

                                        }

                                    }
                                    cont_pos += "</div>";
                                }

                            } else {

                                //Textposition/Abgerufen aus...
                                cont_pos += "<div class='pos_col col_pos_artl'>" + this.receipts[i].positionen[i_pos].artL + "</div>";

                            }

                            cont_pos += "</div>";

                            cont_pos += "<div class='col_pos_wk flaticon2-shopping-cart-1' title='Artikel in den Warenkorb legen'></div>";

                            cont_pos += "</div>";

                            cont_pos += "</div>";

                            cont_search += (cont_search.length >= 0 ? ";" : "");
                            cont_search += this.receipts[i].positionen[i_pos].artNr + ";" + this.receipts[i].positionen[i_pos].artL;

                        }

                        cont_receipt += cont_pos_header + cont_pos;
                        cont_receipt = cont_receipt.replace("$xxx$", cont_search);

                    }

                    cont_receipt += "</div>";

                }

                if (archive == true) {
                    $('.receipt_' + belegart + '.archive').append(cont_receipt_header + cont_receipt);
                } else {
                    $('.receipt_' + belegart + '.open').append(cont_receipt_header + cont_receipt);
                }

            }

            //$('#div_account').html(this.receipts[0].belegNr+','+this.receipts[1].belegNr);


            //console.log(this.receipts[0].belegNr);
            //console.log(this.receipts[1].belegNr);

            this.loadcount++;
            console.log('this.loadcount: '+this.loadcount + ' belegart:'+belegart);
            if (this.loadcount == this.maxcount) {
                this.fillFilter();
            }

            $('#div_' + belegart + ' .count').html(' (' + $('.receipt_' + belegart + ' .receipt').length.toString() + ')');
        });

    }

    loadcustomerdata() {
        //Kundendaten zur Anzeige laden

        this.warenkorbsService.getRechnungsadresse().subscribe((k: Kunde.IKundeDto) => {

            //console.log(k);

            var kunde = (k.anrede != null ? k.anrede + "<br>" : '');

            kunde += ((k.vorname != null ? k.vorname : '') + ' ' + (k.nachname != null ? k.nachname : '')).trim();

            kunde += (k.firmenname != null ? "<br>" + k.firmenname : '');
            kunde += (k.strasse != null ? "<br>" + k.strasse : '');
            kunde += "<br>" + (k.plz != null ? k.plz : '') + ' ' + (k.ort != null ? k.ort : '');

            kunde += (k.email != null ? "<br>email: " + k.email : '');
            kunde += (k.email != null ? "<br>telefon: " + k.telefonFirma : '');

            document.getElementById("kundenkonto_customerdata").innerHTML = kunde;
            document.getElementById("kundenkonto_custno").innerHTML = k.kundennummer.toString();


        });

    }

    onAddToWarenkorb(kennung: number, menge: number, isMatrixArtikel: boolean = false) {

        const _addPosMessage = "Der Artikel wurde zum Warenkorb hinzugefügt!";

        let newPosition = {} as Warenkorb.IAddPositionDto;

        newPosition.artikelKennung = kennung;
        newPosition.menge = menge;
        newPosition.isMatrixArtikel = isMatrixArtikel;

        this.warenkorbsService.addPosition(newPosition).subscribe(res => {
            if (res != null) {
                console.log('anzahlpos: ' + res.warenkorbPositionen.length);
                this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                this.layoutUtilsService.showActionNotification(_addPosMessage, MessageType.Update);
            }

        });

    }

    onAddReceiptToWarenkorb(event) {
        //ganzen Beleg hinzufügen
        const _addPosMessage = "Der/die Artikel wurde(n) zum Warenkorb hinzugefügt!";


        let newArtikels = {} as Warenkorb.IWarenkorbArtikelsDto;
        newArtikels.positionen = [];


        $(event.target).parents('.receipt').find('.position').each(function () {

            let kennung = $(this).attr('data-id');
            let menge = $(this).attr('data-anzahl');

            //let ismatrixArtikel = $(this).attr('data-matrixid');

            let newPosition = {} as Warenkorb.IAddPositionDto;

            newPosition.artikelKennung = parseInt(kennung);
            newPosition.menge = parseFloat(menge);
            //newPosition.isMatrixArtikel = isMatrixArtikel;

            newArtikels.positionen.push(newPosition);


            /*
        export interface IWarenkorbArtikelListDto {


        let newPosition = {} as Warenkorb.IAddPositionDto;

        newPosition.artikelKennung = kennung;
        newPosition.menge = menge;
        newPosition.isMatrixArtikel = isMatrixArtikel;

        this.warenkorbsService.addReceipt(newPosition).subscribe(res => {
            if (res != null) {
                console.log('anzahlpos: '+res.warenkorbPositionen.length);
                this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                this.layoutUtilsService.showActionNotification(_addPosMessage, MessageType.Update);
            }
*/
        });

        this.warenkorbsService.addPositions(newArtikels).subscribe(res => {
            if (res != null) {
                console.log('anzahlpos: ' + res.warenkorbPositionen.length);
                this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                this.layoutUtilsService.showActionNotification(_addPosMessage, MessageType.Update);
            }

        });

        console.log('newArtikels: ' + newArtikels.positionen);

    }

    onSearch() {

        //Filter Kunde auswerten
        if ($('#filter_customer option').length > 1) {
            var kennung = $('#filter_customer').val();
        }

        $('.receipt').show();

        //Filter function
        if (this.search != '' || kennung != 0) {

            let st = (this.search).trim().toUpperCase();

            $('.receipt').filter(function () {

                //welche Filter sind aktiv
                if (kennung == 0 && st != '') {
                    return (!(($(this).attr('data-belegnr').toUpperCase().includes(st)) || ($(this).attr('data-search').toUpperCase().includes(st))));
                } else if (kennung != 0 && st == '') {
                    return ($(this).attr('data-kennung') != kennung.toString());
                } else {
                    return (!(($(this).attr('data-belegnr').toUpperCase().includes(st)) || ($(this).attr('data-search').toUpperCase().includes(st))) && $(this).attr('data-kennung') != kennung.toString());
                }

            }).hide();

        }

        const arr_belegart = ["A", "B", "L"]; //...weitere Belegarten

        arr_belegart.forEach((belegart) => {
            //console.log(belegart);
            $('#div_' + belegart + ' .count').html(' (' + $('#div_'+belegart+' .receipt:not(:hidden)').length.toString() + ')');
        });

    }

    onKeyup(event) {
        console.log(event);

        if (event.keyCode != 13) {
            this.onSearch();
        }
    }

    getNumberWarenkorbItems(event) {
        this.numberWarenkorbItems.emit(event);
    }

    goBack() {
        console.log('--> route to articles');
        this.router.navigate(['/articles'], {
            queryParams: {
                showWarenkorb: false,
                showAdvertise: false
            }
        });
    }

    getaddresslist(kennungen: string): Observable<Kunde.IKundeDto[]> {
        //Kundendaten zur Anzeige laden

        return this.warenkorbsService.getAddresslist(kennungen, false).pipe(
            map(res => {
                // Hier kannst du die Antwort weiter verarbeiten, falls notwendig
                console.log('addresslist: ');
                console.log(res);
                return res; // Rückgabe der Kundenliste
            })
        );

    }

    fillFilter() {

        // Holen der IDs aller Elemente mit der Klasse 'receipt'
        var kennungen = $(".receipt").map(function () {
            return $(this).attr('data-kennung'); // Das 'kennung'-Attribut extrahieren
        }).get(); // .get() gibt das Ergebnis als normales Array zurück

        // Doppelte entfernen
        kennungen = [...new Set(kennungen)];

        //console.log(kennungen.join(",")); // Gibt die Liste der eindeutigen IDs aus

        var customers = this.getaddresslist(kennungen.join(",")).subscribe((customers: any[]) => {
            // Mapping der API-Daten auf das IKundeDto-Interface
            const mappedCustomers: Kunde.IKundeDto[] = customers.map((customer) => {
                return {
                    id: customer.Id,               // Mappen von 'ID' (API) auf 'id' (Kunde.IKundeDto)
                    firmenname: customer.Firmenname, // Mappen von 'Firmenname' (API) auf 'firmenname' (Kunde.IKundeDto)
                    kundennummer: customer.Kundennummer || 0, // Optionales Mappen mit Defaultwerten, falls Werte fehlen
                    nachname: customer.Nachname || "",
                    vorname: customer.Vorname || "",
                    anrede: customer.Anrede || "",
                    plz: customer.Plz || "",
                    ort: customer.Ort || "",
                    strasse: customer.Strasse || "",
                    email: customer.Email || "",
                    telefonFirma: customer.TelefonFirma || ""
                };
            });

            $('#filter_customer').empty();

            $('#filter_customer').append($('<option>', {
                value: 0,
                text: 'alle'
            }));

            // Iteriere nun über die gemappten Kunden
            $.each(mappedCustomers, (index: number, cust_item: Kunde.IKundeDto) => {
                $('#filter_customer').append($('<option>', {
                    value: cust_item.id.toString(), // Zugriff auf id
                    text: `${cust_item.firmenname}` // Zugriff auf firmenname
                }));
            });
        });

    }
}
